import { Actionsheet, Area } from "vant";
import { Component, Vue } from "vue-property-decorator";
import PickerManager from "@/shared/tools/pickerManager";
import { OptionItem } from "@/model/OptionItem";
import { AreaJsonData, AreaPickerOptions, ResetableArea } from "./types";

@Component
class AreaPicker extends Vue {
  $refs!: {
    Area: ResetableArea;
  };

  private visible = false;

  private options: AreaPickerOptions | null = null;

  private areas: AreaJsonData = Object.create(null);

  public open(options: AreaPickerOptions, areas?: AreaJsonData) {
    this.visible = true;
    this.options = {
      value: "",
      itemHeight: 44,
      manualClose: false,
      ...options,
    };

    if (areas) {
      this.areas = areas;
    }

    const refArea = this.$refs.Area;

    if (!this.options.value && refArea) {
      refArea.reset();
    }
  }

  public close() {
    this.visible = false;
  }

  private render() {
    return this.options ? (
      <Actionsheet v-model={this.visible}>
        <Area
          ref="Area"
          areaList={this.areas}
          value={this.options.value}
          title={this.options.title}
          loading={this.options.loading}
          item-height={this.options.itemHeight}
          confirm-button-text={this.options.confirmButtonText}
          cancel-button-text={this.options.cancelButtonText}
          onCancel={this.onCancel}
          onConfirm={this.onConfirm}
        />
      </Actionsheet>
    ) : null;
  }

  private onCancel() {
    this.visible = false;

    if (this.options && this.options.onCancel) {
      this.options.onCancel();
    }
  }

  private onConfirm(value: [OptionItem, OptionItem, OptionItem]) {
    if (this.options) {
      if (!this.options.manualClose) {
        this.close();
      }

      this.options.onConfirm({
        provinceCode: String(value[0].code),
        province: value[0].name,
        cityCode: String(value[1].code),
        city: value[1].name,
        districtCode: String(value[2].code),
        district: value[2].name,
      });
    }
  }
}

let instance: AreaPicker;

export const areaPicker = {
  open(options: AreaPickerOptions, areas?: AreaJsonData): void {
    if (!instance) {
      instance = new AreaPicker().$mount();
      document.body.appendChild(instance.$el);
      PickerManager.addPicker(instance);
    }

    return instance.open(options, areas);
  },

  close(): void {
    if (instance) {
      instance.close();
    }
  },
};
